import omit from 'lodash.omit'
import { sortIntl } from '~/utils/sorting'
import { UI_LANGUAGES, LANGUAGE_PL } from '~/utils/constants'

export default {
  data () {
    return {
      UI_LANGUAGES,
    }
  },
  computed: {
    languageOptions () {
      return sortIntl(
        Object.entries(this.UI_LANGUAGES)
          .map(([code, text]) => ({ value: code, text })),
        ({ text }) => text)
    },
    localizedLanguageOptions () {
      const displayNames = new Intl.DisplayNames([this.$store.state.language], { type: 'language' })

      return sortIntl(
        Object.keys(this.UI_LANGUAGES)
          .map(code => ({ value: code, text: displayNames.of(code) })),
        ({ text }) => text
      )
    },
  },
  mounted () {
    this.$ph.onFeatureFlags(() => {
      if (this.$ph.isFeatureEnabled('polish-language')) {
        this.UI_LANGUAGES = { ...this.UI_LANGUAGES, [LANGUAGE_PL]: 'Polski' }
      } else {
        this.UI_LANGUAGES = omit(this.UI_LANGUAGES, [LANGUAGE_PL])
      }
    })
  }
}
